import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useLocation } from 'react-router-dom';
import { formatReadableAmount } from '../../../../Common/FormatFunctions/FormatAmount';
import { RingLoader } from 'react-spinners';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, TableFooter } from "@mui/material";
import { FormaDateBalanceSheet } from '../../../../Common/FormatFunctions/FormatDate';
import PdfPreview from '../../../../Common/PdfPreview_Default';

const apikey = process.env.REACT_APP_API;

const SaleBillSaudaDateRegister = () => {
    const location = useLocation();
    const Company_Name = sessionStorage.getItem('Company_Name')
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')
    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const company_Code = searchParams.get('Company_Code');
    const YearCode = searchParams.get('Year_Code');
    const acCode = searchParams.get('acCode');
    const [pdfPreview, setPdfPreview] = useState(null);

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [reportType, setReportType] = useState("PartyWise");

    const reportTypeFromUrl = searchParams.get("Report_Type") || "PartyWise";
    const reportTypeSaudaUrl = searchParams.get("Sauda_Type") || "ALL";

    useEffect(() => {
        setReportType(reportTypeFromUrl);
    }, [reportTypeFromUrl]);


    const [grandTotals, setGrandTotals] = useState({
        Bill_Amount: 0,
        Commission: 0,
        TDS_Amt: 0,
        Payable: 0,
    });

    const API_URL = `${apikey}/SaleBill_RegisterReport`;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear());
        return `${day}/${month}/${year}`;
    };



    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        fromDate: fromDate,
                        toDate: toDate,
                        Company_Code: company_Code,
                        Year_Code: YearCode,
                        reportTypeSaudaUrl
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        fetchReportData();
    }, [API_URL]);


    useEffect(() => {
        if (reportData.length > 0) {
            const totals = reportData.reduce(
                (acc, item) => {
                    const billAmt = Number(item.Bill_Amount) || 0;
                    const tds = Number(item.TDS_Amt) || 0;
                    const payable = billAmt - tds;

                    acc.Bill_Amount += billAmt;
                    acc.Commission += Number(item.Commission) || 0;
                    acc.TDS_Amt += tds;
                    acc.Payable += payable;

                    return acc;
                },
                { Bill_Amount: 0, Commission: 0, TDS_Amt: 0, Payable: 0 }
            );

            setGrandTotals(totals);
        }
    }, [reportData]);




    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();

        const headers = [
            "Bill No",
            "Bill Date",
            "Sauda Date",
            "Party Name",
            "Bill Amount",
            "Commission",
            "TDS",
            "Payable"
        ];

        let excelData = [];


        excelData.push([Company_Name]);
        excelData.push([`GSTN: ${Company_GSTNO}`]);
        excelData.push(["Sale Register"]);
        excelData.push([`From: ${fromDate} To: ${toDate}`]);
        excelData.push([]); // empty row for spacing


        excelData.push(headers);


        let grandBill = 0, grandComm = 0, grandTds = 0, grandPay = 0;

        const groupedData = groupByDateGlobal(reportData);

        Object.entries(groupedData).forEach(([date, rows]) => {
            // Date row
            excelData.push([`Date : ${date}`]);

            let dateBill = 0, dateComm = 0, dateTds = 0, datePay = 0;

            rows.forEach(item => {
                const billAmt = Number(item.Bill_Amount) || 0;
                const comm = Number(item.Commission) || 0;
                const tds = Number(item.TDS_Amt) || 0;
                const payable = billAmt - tds;

                dateBill += billAmt;
                dateComm += comm;
                dateTds += tds;
                datePay += payable;

                grandBill += billAmt;
                grandComm += comm;
                grandTds += tds;
                grandPay += payable;

                excelData.push([
                    item.doc_no,
                    item.doc_date,
                    item.SaudaDate,
                    item.CustomerName,
                    billAmt,
                    comm,
                    tds,
                    payable
                ]);
            });

            // Date total row
            excelData.push(["", "", "", `Date Total (${date})`, dateBill, dateComm, dateTds, datePay]);

            excelData.push([]);
        });

        // Grand total
        excelData.push(["", "", "", "Grand Total", grandBill, grandComm, grandTds, grandPay]);

        // Convert to sheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Column widths
        ws["!cols"] = [
            { wch: 12 },
            { wch: 12 },
            { wch: 12 },
            { wch: 25 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 },
            { wch: 15 }
        ];

        XLSX.utils.book_append_sheet(wb, ws, "SaleRegister");
        XLSX.writeFile(wb, "SaleRegister.xlsx");
    };


    const handlePrint = () => {
        const companyName = Company_Name;
        const fromDateParam = searchParams.get('fromDate');
        const toDateParam = searchParams.get('toDate');

        const doc = generatePDFDocument(companyName, fromDateParam, toDateParam);
        const pdfUrl = URL.createObjectURL(doc);
        const printWindow = window.open(pdfUrl);
        printWindow.onload = function () {
            setTimeout(() => {
                printWindow.print();
            }, 500);
        };
    };



    const generatePDFDocument = (companyName, fromDate, toDate) => {
        const doc = new jsPDF();

        // HEADER
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(companyName, doc.internal.pageSize.width / 2, 15, { align: 'center' });

        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(`GSTN : ${Company_GSTNO}`, doc.internal.pageSize.width / 2, 23, { align: 'center' });

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text("Sale Register", doc.internal.pageSize.width / 2, 32, { align: 'center' });

        doc.setFontSize(10);
        doc.text(`${FormaDateBalanceSheet(fromDate)} to ${FormaDateBalanceSheet(toDate)}`, doc.internal.pageSize.width / 2, 40, { align: 'center' });

        const bodyRows = [];

        let grandBill = 0, grandComm = 0, grandTds = 0, grandPay = 0;


        if (reportType === "PartyWise") {

            const groupedData = groupByDateGlobal(reportData);

            Object.entries(groupedData).forEach(([date, group]) => {

                bodyRows.push([{
                    content: `Date : ${date}`,
                    colSpan: 9,
                    styles: { fontStyle: 'bold', fillColor: [227, 242, 253] }
                }]);

                let dateBill = 0, dateComm = 0, dateTds = 0, datePay = 0;

                group.forEach(row => {   // ✅ FIXED
                    const bill = Number(row.Bill_Amount) || 0;
                    const comm = Number(row.Commission) || 0;
                    const tds = Number(row.TDS_Amt) || 0;
                    const pay = bill - tds;

                    dateBill += bill;
                    dateComm += comm;
                    dateTds += tds;
                    datePay += pay;

                    grandBill += bill;
                    grandComm += comm;
                    grandTds += tds;
                    grandPay += pay;

                    bodyRows.push([
                        row.doc_no,
                        row.doc_date,
                        row.SaudaDate || "-",
                        row.CustomerName,
                        formatReadableAmount(bill),
                        formatReadableAmount(row.Commission_Rate),
                        formatReadableAmount(comm),
                        formatReadableAmount(tds),
                        formatReadableAmount(pay)
                    ]);
                });

                // Date Total
                bodyRows.push([
                    '', '','',
                    { content: `Date Total (${date})`, styles: { fontStyle: 'bold' } },
                    {content:formatReadableAmount(dateBill), styles: { fontStyle: 'bold' }},
                    '',
                    {content:formatReadableAmount(dateComm), styles: { fontStyle: 'bold' }},
                    {content:formatReadableAmount(dateTds), styles: { fontStyle: 'bold' }},
                    {content:formatReadableAmount(datePay), styles: { fontStyle: 'bold' }}
                ]);
            });

        } else {
            // TOTAL MODE (NON PARTYWISE)

            const grouped = groupByPartyForNonParty(reportData);

            grouped.forEach(row => {
                const bill = row.Bill_Amount;
                const comm = row.Commission;
                const tds = row.TDS_Amt;
                const pay = row.Payable;

                grandBill += bill;
                grandComm += comm;
                grandTds += tds;
                grandPay += pay;

                bodyRows.push([
                    row.CustomerName,
                    formatReadableAmount(bill),
                    formatReadableAmount(row.Commission_Rate),
                    formatReadableAmount(comm),
                    formatReadableAmount(tds),
                    formatReadableAmount(pay)
                ]);
            });
        }
        // GRAND TOTAL
        if (reportType === "PartyWise") {
            bodyRows.push([
                {
                    content: 'Grand Total',
                    colSpan: 4,
                    styles: { fontStyle: 'bold', halign: 'right' }
                },
                {content:formatReadableAmount(grandBill), styles: { fontStyle: 'bold' } },
                '',
                {content:formatReadableAmount(grandComm), styles: { fontStyle: 'bold' } },
                {content:formatReadableAmount(grandTds), styles: { fontStyle: 'bold' } },
                {content:formatReadableAmount(grandPay), styles: { fontStyle: 'bold' } }
            ]);
        } else {
            bodyRows.push([
                { content: 'Grand Total', styles: { fontStyle: 'bold' } },
                {content:formatReadableAmount(grandBill), styles: { fontStyle: 'bold' } },
                '',
                {content:formatReadableAmount(grandComm), styles: { fontStyle: 'bold' } },
                {content:formatReadableAmount(grandTds), styles: { fontStyle: 'bold' } },
                {content:formatReadableAmount(grandPay), styles: { fontStyle: 'bold' } }
            ]);
        }

        // TABLE HEAD BASED ON TYPE
        const head = reportType === "PartyWise"
            ? [["Bill No", "Bill Date", "Sauda Date", "Party Name","Bill Amount", "Commission Rate", "Commission", "TDS", "Payable"]]
            : [["Party Name", "Bill Amount", "Commission Rate", "Commission", "TDS", "Payable"]];

        doc.autoTable({
            head: head,
            body: bodyRows,
            startY: 45,
            styles: {
                fontSize: 8,
                lineWidth: 0.1,
                lineColor: [0, 0, 0] // light gray lines
            },
            headStyles: {
                fillColor: [255, 0, 0],
                textColor: [255, 255, 255],
                lineWidth: 0
            },
            bodyStyles: {
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
                textColor: [0, 0, 0],
            },
            tableLineWidth: 0.1,
            tableLineColor: [200, 200, 200]
        });

        const pdfBlob = doc.output('blob');
        setPdfPreview(URL.createObjectURL(pdfBlob));

        return pdfBlob;
    };

    const groupReportData = (data) => {
        const groupedData = {};
        data.forEach((item) => {
            const key = `${item.salebillId}`;
            if (!groupedData[key]) {
                groupedData[key] = {
                    items: [],
                    totalQty: 0,
                };
            }
            groupedData[key].items.push(item);
            groupedData[key].totalQty += parseFloat(item.Bill_Amount) || 0;
        });
        return groupedData;
    };

    const groupedReportData = groupReportData(reportData);

    const groupByCustomer = (data) => {
        const grouped = {};

        data.forEach((item) => {
            const key = item.Ac_Code;

            if (!grouped[key]) {
                grouped[key] = {
                    CustomerName: item.CustomerName,
                    Bill_Amount: 0,
                    Commission: 0,
                    TDS_Amt: 0,
                    Payable: 0,
                    rows: []
                };
            }

            const billAmt = Number(item.Bill_Amount) || 0;
            const commission = Number(item.Commission) || 0;
            const tds = Number(item.TDS_Amt) || 0;
            const payable = billAmt - tds;


            grouped[key].Bill_Amount += billAmt;
            grouped[key].Commission += commission;
            grouped[key].TDS_Amt += tds;
            grouped[key].Payable += payable;

            grouped[key].rows.push(item);
        });

        return grouped;
    };

    const groupedData = groupByCustomer(reportData);


    const groupByDateGlobal = (data) => {
        const grouped = {};

        data.forEach(item => {
            const date = item.doc_date;
            if (!grouped[date]) {
                grouped[date] = [];
            }
            grouped[date].push(item);
        });

        return grouped;
    };



    const totalColumns = reportType === "PartyWise" ? 4 : 1;


    const groupByPartyForNonParty = (data) => {
        const grouped = {};

        data.forEach(item => {
            const key = item.CustomerName; // or Customer_Code if safer

            if (!grouped[key]) {
                grouped[key] = {
                    CustomerName: item.CustomerName,
                    Bill_Amount: 0,
                    Commission_Rate: item.Commission_Rate,
                    Commission: 0,
                    TDS_Amt: 0,
                    Payable: 0
                };
            }

            const bill = Number(item.Bill_Amount) || 0;
            const comm = Number(item.Commission) || 0;
            const tds = Number(item.TDS_Amt) || 0;
            const pay = bill - tds;

            grouped[key].Bill_Amount += bill;
            grouped[key].Commission += comm;
            grouped[key].TDS_Amt += tds;
            grouped[key].Payable += pay;
        });

        return Object.values(grouped);
    };



    return (
        <div style={{ marginTop: "10px" }}>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Sale Register</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>

            <div className="mb-3 row align-items-center">
                <div className="col-auto">
                    <button className="btn btn-secondary me-2" onClick={handlePrint}>
                        Print
                    </button>
                    <button className="btn btn-success" onClick={handleExportToExcel}>
                        Export to Excel
                    </button>
                    <button className="btn btn-secondary me-2" onClick={() => generatePDFDocument(Company_Name, fromDate, toDate)}>
                        Preview PDF
                    </button>
                    {pdfPreview && (
                        <PdfPreview
                            pdfData={pdfPreview}
                            apiData={reportData[0]}
                            label={"SaleRegister"}
                        />
                    )}
                </div>
            </div>

            <div style={{
                maxHeight: 'calc(100vh - 200px)',
                overflow: 'auto',
                position: 'relative',
                border: '1px solid #e0e0e0',
                marginBottom: '60px'
            }} id="reportTable">

                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white'
                    }}>
                        <TableRow>
                            {reportType === "PartyWise" && (
                                <>
                                    <TableCell sx={{ fontWeight: "bold" }}>Bill No</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Bill Date</TableCell>
                                    <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>
                                        Sauda Date
                                    </TableCell>
                                </>
                            )}

                            <TableCell sx={{ fontWeight: "bold", textAlign: "left" }}>
                                Party Name
                            </TableCell>

                            <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                Bill Amount
                            </TableCell>


                            <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                Commission Rate
                            </TableCell>

                            <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                Commission
                            </TableCell>

                            <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                TDS
                            </TableCell>

                            <TableCell sx={{ fontWeight: "bold", textAlign: "right" }}>
                                Payable
                            </TableCell>
                        </TableRow>

                    </TableHead>

                    <TableBody>
                        {reportType === "PartyWise" ? (
                            Object.entries(groupByDateGlobal(reportData)).map(([date, rows], dIdx) => {

                                let dateBill = 0;
                                let dateComm = 0;
                                let dateTds = 0;
                                let datePay = 0;

                                return (
                                    <React.Fragment key={dIdx}>

                                        {/* 🔹 DATE HEADER */}
                                        <TableRow sx={{ backgroundColor: "#e3f2fd" }}>
                                            <TableCell colSpan={9} sx={{ fontWeight: "bold" }}>
                                                Date : {date}
                                            </TableCell>
                                        </TableRow>

                                        {/* 🔹 DATE ROWS */}
                                        {rows.map((row, i) => {
                                            const bill = Number(row.Bill_Amount) || 0;
                                            const comm = Number(row.Commission) || 0;
                                            const tds = Number(row.TDS_Amt) || 0;
                                            const pay = bill - tds;

                                            dateBill += bill;
                                            dateComm += comm;
                                            dateTds += tds;
                                            datePay += pay;

                                            return (
                                                <TableRow key={`${dIdx}-${i}`}>
                                                    <TableCell>{row.doc_no}</TableCell>
                                                    <TableCell align="center">{row.doc_date}</TableCell>
                                                    <TableCell align="center">{row.SaudaDate || "-"}</TableCell>
                                                    <TableCell>{row.CustomerName}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(bill)}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(row.Commission_Rate)}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(comm)}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(tds)}</TableCell>
                                                    <TableCell align="right">{formatReadableAmount(pay)}</TableCell>
                                                </TableRow>
                                            );
                                        })}

                                        {/* 🔹 DATE TOTAL */}
                                        <TableRow sx={{ backgroundColor: "#fff9c4" }}>
                                            <TableCell colSpan={4} sx={{ fontWeight: "bold" }}>
                                                Date Total ({date})
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                {formatReadableAmount(dateBill)}
                                            </TableCell>
                                            <TableCell />
                                            <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                {formatReadableAmount(dateComm)}
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                {formatReadableAmount(dateTds)}
                                            </TableCell>
                                            <TableCell align="right" sx={{ fontWeight: "bold" }}>
                                                {formatReadableAmount(datePay)}
                                            </TableCell>
                                        </TableRow>

                                    </React.Fragment>
                                );
                            })
                        ) : (
                            /* Non PartyWise remains same */
                            <>
                                {groupByPartyForNonParty(reportData).map((row, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>{row.CustomerName}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(row.Bill_Amount)}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(row.Commission_Rate)}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(row.Commission)}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(row.TDS_Amt)}</TableCell>
                                        <TableCell align="right">{formatReadableAmount(row.Payable)}</TableCell>
                                    </TableRow>
                                ))}




                            </>


                        )}

                    </TableBody>
                    <TableFooter
                        sx={{
                            position: 'sticky',
                            bottom: 0,
                            backgroundColor: 'white',
                            zIndex: 1
                        }}
                    >
                        <TableRow sx={{ backgroundColor: 'yellow' }}>
                            <TableCell
                                colSpan={totalColumns}
                                sx={{ fontWeight: 'bold', fontSize: '14px' }}
                            >
                                Total
                            </TableCell>


                            <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px' }}>{formatReadableAmount(grandTotals.Bill_Amount)}</TableCell>
                            <TableCell />
                            <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px' }}> {formatReadableAmount(grandTotals.Commission)} </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px' }}> {formatReadableAmount(grandTotals.TDS_Amt)} </TableCell>
                            <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '14px' }}> {formatReadableAmount(grandTotals.Payable)} </TableCell>
                        </TableRow>
                    </TableFooter>

                </Table>
            </div>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999
                }}>
                    <RingLoader size={80} />
                </div>
            )}
            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default SaleBillSaudaDateRegister;

